<template>
<div class="container">

<div class="form">

<div class="row">
	<div class="col-3 left" style="letter-spacing:.2rem;">原密码</div>
	<div class="col-7">
		<mt-field placeholder="请输入密码" v-model="f.psd" type="password"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left" style="letter-spacing:0;">设置密码</div>
	<div class="col-7">
		<mt-field placeholder="请输入密码" v-model="f.psd1" type="password"></mt-field>
	</div>
</div>

<div class="row">
	<div class="col-3 left" style="letter-spacing:0;">确认密码</div>
	<div class="col-7">
		<mt-field placeholder="请再次输入密码" v-model="f.psd2" type="password"></mt-field>
	</div>
</div>

</div>

<div class="row pd">
	<mt-button type="primary" size="large" @click="sub">确认修改</mt-button>
</div>

</div>	
</template>

<style scoped>
.container{background: rgb(251,251,251);}	
.pd{padding:.5rem 1rem;}
</style>

<script>

export default {
	data:function(){
		return {
			f:{psd:"",psd1:"",psd2:""}
		}
	},
	created:function(){
		this.$emit("setTitle","修改密码");
	},
	methods:{
     sub:function(){
     	 var _this=this;
     	fun.post(mydata.apiuser+"change_psd",this.f,function(d){
     		console.log(d);
     		if(d.status==1){
     			_this.$messagebox.alert("修改成功，请重新登录").then(function(){
     				_this.$router.push("/login");
     			})
     		}else{
     			_this.$toast(d.info);
     		}
     	})
     }
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/safe.vue